module.exports = __webpack_public_path__ + "static/media/covi_han_san.690977df.png";